var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-content"},[_c('img',{attrs:{"src":require("../../../assets/image/success.png"),"alt":""}}),_c('div',{staticClass:"success-text"},[_vm._v("创建成功！")]),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }